import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import TransparentOrigins from "./sections/TransparentOrigins";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <TransparentOrigins />
      <FrequentlyAskedQuestions />
      <Faq />
      <Footer />
    </div>;
}